import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { CKEditorModule } from 'ng2-ckeditor';

import { FileUploaderInputComponent } from './file-uploader-input/file-uploader-input.component';
import { HtmlEditorComponent } from './html-editor/html-editor.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        CKEditorModule
    ],
    declarations: [FileUploaderInputComponent, HtmlEditorComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [FileUploaderInputComponent, HtmlEditorComponent]
})
export class ToolsModule { }
